import React from "react";
import { useSelector } from "react-redux";

export default function Destek() {
  const getUserInfo = useSelector((state) => state.getUserInfo);

  return (
    <div>
      <iframe src={"https://destek.noktasal.com.tr/liste/15/" + getUserInfo.Username + "/16"} style={{ width: "100%", height: "100vh" }} title="destek" />
    </div>
  );
}
